function gradientHeightCheck() {
	if ($(".text-content").height() < 600) {
		$(".text-content").css("background-size", "100% 100%");
	} else {
		return false;
	}
}